const OwnDeliveryActiveUfsEnum = Object.freeze({
  BA: "BA",
  RJ: "RJ",
  SP: "SP"
});

export { OwnDeliveryActiveUfsEnum };
